<template>
	<div class="nav-bar-item">
		<b-nav-item :class="getClasses()" :path="path" :to="to"><slot name="item-text"></slot></b-nav-item>
	</div>
	<!-- <b-nav-item :class="getClasses()" path="/home" to="/home">首页</b-nav-item>
	<b-nav-item :class="getClasses()" path="/sentiment" to="/sentiment/cyclicality">情绪</b-nav-item>
	<b-nav-item :class="getClasses()" path="/review" to="/review/uplimit">复盘</b-nav-item>
	<b-nav-item :class="getClasses()" path="/robot" to="/robot/hot">机器人</b-nav-item> -->
</template>

<script>
	export default {
		name: 'NavBarItem',
		props:{
			path:{
				type:String,
				default:'',
			},
			to:{
				type:String,
				default:'',
			}
		},
		data() {
			return {
				// isActive: true
			}
		},
		computed:{
			isActive(){
				return this.$route.path.indexOf(this.path) != -1
			},
		},
		methods: {
			getClasses: function() {
				return {
					active: this.isActive
				}
			}
		}
	}    
</script>

<style>
</style>
